/*
 * File: cell-action-source-download.ts
 * Created: 2026-02-05
 * Author: Val Liu
 */

import { Component, Watch } from "vue-property-decorator";
import CellActionBase from "@root/components/table/elements/body/cell-action/base/cell-action-base";

@Component
export default class CellActionSourceDownload extends CellActionBase {
    get defaultLabel(): string {
        return this.label ?? "w_FailedJobDownloadSource";
    }

    @Watch("row", { immediate: true, deep: true })
    handleRowChange() {
        this.setVisible(true);
    }

    get isDisabled() {
        const inputFile = this.row?.inputFile as any;
        const fileId =
            inputFile?.id ?? (typeof inputFile === "string" ? inputFile : null);
        return !fileId;
    }

    handleClick(event: Event) {
        const inputFile = this.row?.inputFile as any;
        const fileId =
            inputFile?.id ?? (typeof inputFile === "string" ? inputFile : null);
        if (!fileId) {
            event.preventDefault();
            return;
        }
        const baseUrl = this.$server.UrlFile();
        const authHeaders = this.$server.applyAccessToken?.() ?? {};
        const auth = (authHeaders as Record<string, string>)["Authorization"] ?? "";
        const token = auth.replace(/^Bearer\\s+/i, "");
        const url =
            `${baseUrl}id=${encodeURIComponent(String(fileId))}` +
            (token ? `&token=${encodeURIComponent(token)}` : "");
        window.location.href = url;
    }
}
